import * as Sentry from "@sentry/nextjs"
import axios from "axios"

import { ApiResponse } from "@shared/types/api/common"
import { JsonFormatterOut } from "@shared/types/api/formatters"

const axios_config = {
  headers: {
    "Content-Type": "application/json",
  },
}

const FormattersApi = {
  json: async (rawJson: string) => {
    try {
      const { data } = await axios.post<ApiResponse<JsonFormatterOut>>(
        `/api/formatters/json`,
        JSON.stringify({ data: rawJson }),
        axios_config
      )
      const result = data.result
      return { result }
    } catch (err) {
      Sentry.captureException(err)
      return { result: null }
    }
  },
}

export default FormattersApi
